import Button from '@material-ui/core/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './button-save.scss';

export interface ButtonSaveProps {
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

export const ButtonSave = (props: ButtonSaveProps): JSX.Element => {
    const { t } = useTranslation();

    const handleClick = () => {
        if (!(props.isLoading || props.disabled)) {
            props.onClick();
        }
    };

    return (
        <div className="button__style--fourth">
            <Button variant="contained" onClick={handleClick} disabled={props.disabled || props.isLoading}>
                {t('accept-invite.buttons.save').toUpperCase()}
            </Button>
        </div>
    );
};

export default ButtonSave;
